import React, { useState, useRef } from "react";
import { useQuery } from "react-query";
import { DataTable } from "primereact/datatable";
import authApi from "../../../service/IdApi";
import PageLoading from "../../../components/PageLoading";
import PageLoadError from "../../../components/PageLoadError";
import PageHeading from "../../../components/PageHeading";
import { Column } from "primereact/column";
import { Button } from 'primereact/button';
import { InputSwitch } from "primereact/inputswitch";

const AllUsers = () => {
    const [users, setUsers] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const [showId, setShowId] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const dataTable = useRef(null);
    const menu = useRef(null);

    const [lazyState, setlazyState] = useState({
        first: 0,
        rows: 50,
        page: 1,
        sortField: "createdAt",
        sortOrder: 0,
    });

    let params = "?first=" + lazyState.first + "&rows=" + lazyState.rows;
    if (lazyState.sortField) {
        params += "&sortField=" + lazyState.sortField;
        if (lazyState.sortOrder) {
            params += "&sortOrder=" + lazyState.sortOrder;
        }
    }

    const { isLoading, isError, data } = useQuery(["Users", params], async () => {
        var searchBody = {};
        searchBody.first = lazyState.first;
        searchBody.rows = lazyState.rows;
        searchBody.sortField = lazyState.sortField;
        searchBody.sortOrder = lazyState.sortOrder;
        const result = await authApi.post("admin/user/list", searchBody);
        setUsers(result.data.users);
        setTotalRecords(result.data.totalRecords);
        setLoaded(true);
        return data;
    });

    const pageHeader = (
        <PageHeading pageTitle="Admin - All Users">
            <div className="block">
            </div>
        </PageHeading>
    );

    if (isLoading) {
        return (
            <div>
                {pageHeader}
                <PageLoading />
            </div>
        );
    }

    if (isError) {
        return (
            <div>
                {pageHeader}
                <PageLoadError />
            </div>
        );
    }

    if (!loaded) {
        return (
            <div>
                {pageHeader}
                <PageLoading />
            </div>
        );
    }

    const onPage = (event) => {
        setlazyState(event);
    };

    const onSort = (event) => {
        setlazyState(event);
    };

    const onRowSelect = (event) => {
        // if (event.type !== "checkbox") {
        //     navigate("edit/" + event.data.itemNumber);
        // }
    };

    const exportCSV = (selectionOnly) => {
        dataTable.current.exportCSV({ selectionOnly });
    };

    const authMethodBodyTemplate = (rowData) => {
        var value = "Wallist";
        if (rowData.authmethod === 2) {
            value = "Facebook";
        }
        else if (rowData.authmethod === 3) {
            value = "Google";
        }
        return (
            <>
                <span>{value}</span>
            </>
        );
    };

    const showActionMenu = (e, rowData) => {
        setSelectedUser(rowData);
        menu.current.toggle(e);
    };
    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button
                    icon="pi pi-bars"
                    className="p-button-rounded p-button-icon-only p-button-text text-800"
                    onClick={(e) => showActionMenu(e, rowData)}
                    aria-controls="popup_menu"
                    aria-haspopup
                    tooltip="Profile Actions"
                    tooltipOptions={{ showDelay: 1000 }}
                />
            </div>
        );
    };
    const emailBodyTemplate = (rowData) => {
        return (
            <a href={`/account/admin/user-events?email=${rowData.email}`}>
                {rowData.email}
            </a>
        );
    };

    return (
        <div>
            {pageHeader}
            <div className="layout-content">
                {totalRecords > 0 && (
                    <div className="card pt-3 sm:pt-0">
                        <div className="flex py-3 w-full">
                            <div className="flex flex-row">
                                <div className="flex mr-3 font-bold">
                                    Show/Hide Columns
                                </div>
                                <div className="flex mr-3">
                                    <span className="mr-1">ID</span>
                                    <InputSwitch checked={showId} onChange={(e) => setShowId(e.value)} />
                                </div>
                            </div>
                            <div className="flex flex-row flex-grow-1 justify-content-end">
                                <Button type="button" icon="pi pi-file-export" onClick={() => exportCSV(false)} data-pr-tooltip="CSV" label="Export" />
                            </div>
                        </div>

                        <DataTable
                            ref={dataTable}
                            value={users}
                            // selection={selectedItems}
                            dataKey="id"
                            paginator
                            rows={lazyState.rows}
                            rowsPerPageOptions={[5, 25, 50, 100, 500]}
                            className="datatable-responsive"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
                            emptyMessage="No users found."
                            responsiveLayout="scroll"
                            onRowSelect={onRowSelect}
                            lazy
                            first={lazyState.first}
                            totalRecords={totalRecords}
                            onPage={onPage}
                            onSort={onSort}
                            sortField={lazyState.sortField}
                            sortOrder={lazyState.sortOrder}
                            loading={isLoading || !loaded}
                        >
                            <Column field="email" body={emailBodyTemplate} header="Email" sortable />
                            <Column field="emailVerified" header="Email Verified" sortable />
                            <Column body={authMethodBodyTemplate} header="Auth Method" sortable />
                            <Column field="lastLoginAt" header="Last Login Date" sortable />
                            <Column field="createdAt" header="Created On" sortable />
                            {showId && (
                                <Column field="id" header="ID" sortable />
                            )}
                        </DataTable>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AllUsers;
